import React from 'react';
import PropTypes from 'prop-types';

import styles from './index.module.scss';

const ImageBlock = ({ label, image }) => (
  <div className={styles['how-gifts-work__item']}>
    <h3>{label}</h3>
    <img src={image.url} alt={image.alt} title={image.alt} width={405} height={318} />
  </div>
);

const HowGiftsWork = ({ items = [] }) => {
  // Do not render if configuration is incomplete / broken.
  if (items.labels.length !== items.images.length) {
    return null;
  }

  return (
    <div className={styles['how-gifts-work']}>
      {items.labels.map((label, index) => (
        <ImageBlock key={index} label={label} image={items.images[index]} />
      ))}
    </div>
  );
};

ImageBlock.propTypes = {
  label: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
};

HowGiftsWork.propTypes = {
  items: PropTypes.shape({
    labels: PropTypes.array,
    images: PropTypes.array,
  }),
};

export default HowGiftsWork;
